import { Outlet, ScrollRestoration, useNavigation } from 'react-router'
import { InfoIcon } from 'lucide-react'
import { Container } from '@/components/layout'
import { ParticipationProvider } from '@/features/consent/ParticipationProvider'
import { useSettings } from '@/features/proposals/queries'
import { cn } from '@/lib/utils'
import { BottomNav } from './BottomNav'
import { useTabBarVisible } from './navigation'
import { SiteFooter } from './SiteFooter'
import { SiteHeader } from './SiteHeader'

function NavigationProgress() {
  const navigation = useNavigation()
  if (navigation.state === 'idle') return null
  return (
    <div className="fixed inset-x-0 top-0 z-50 h-0.5 overflow-hidden bg-transparent" role="progressbar" aria-label="Carregando página">
      <div className="h-full w-1/3 animate-[pa-progress_1.2s_ease-in-out_infinite] bg-primary" />
    </div>
  )
}

function AnnouncementBar() {
  const { data: settings } = useSettings()
  const text = settings?.announcement?.trim()
  if (!text) return null
  return (
    <div className="border-b border-white/70 bg-secondary text-secondary-foreground">
      <Container className="flex items-start gap-2 py-2.5 text-sm">
        <InfoIcon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
        <p>{text}</p>
      </Container>
    </div>
  )
}

export function RootLayout() {
  const tabBarVisible = useTabBarVisible()
  return (
    <ParticipationProvider>
      <a
        href="#conteudo"
        className="sr-only z-50 rounded-md bg-primary px-4 py-2 text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4"
      >
        Pular para o conteúdo
      </a>
      <NavigationProgress />
      {/* Com a navegação inferior do celular, o fim da página fica acima dela. */}
      <div
        className={cn(
          'flex min-h-dvh flex-col',
          tabBarVisible && 'pb-[calc(var(--tabbar-height)+env(safe-area-inset-bottom))] md:pb-0',
        )}
      >
        <AnnouncementBar />
        <SiteHeader />
        <main id="conteudo" tabIndex={-1} className="flex-1 outline-none">
          <Outlet />
        </main>
        <SiteFooter />
      </div>
      <BottomNav />
      <ScrollRestoration />
    </ParticipationProvider>
  )
}
